// accepts a JSON string
// it replaces the "deleted" property with "is_deleted" in JSON strings
export function aliasDeletedProperty(data: string): string {
  return data.replace(
    /"deleted":/g,
    "\"is_deleted\":",
  )
}
